import React from 'react';
import { HeaderMenuItem } from '@carbon/react';

import { NavLink } from 'react-router-dom';
import useUser from '@/lib/hooks/useUser';

const AdminMenu = React.lazy(() =>
  import(
    /* webpackChunkName: 'AdminMenu' */ '../../adminContent/Navigation/MenuItem'
  )
);

const MenuItems = () => {

  const {isAdmin} = useUser();

  return (
    <>
      <HeaderMenuItem as={NavLink} to="/">
        Dashboard
      </HeaderMenuItem>
      <HeaderMenuItem as={NavLink} to="/elements">
        Elemente
      </HeaderMenuItem>
      <HeaderMenuItem as={NavLink} to="/streams">
        Streams
      </HeaderMenuItem>
      <HeaderMenuItem as={NavLink} to="/locations">
        Standorte
      </HeaderMenuItem>
      {isAdmin && (
        <HeaderMenuItem as={NavLink} to="/devices">
          Geräte
        </HeaderMenuItem>
      )}
      <HeaderMenuItem as={NavLink} to="/help">
        Hilfe
      </HeaderMenuItem>
      {isAdmin && <AdminMenu />}
    </>
  );
};

export default MenuItems;
